import { Task, ChainActivity } from '@ts-ioc/activities';

@Task('gen-lib')
export class GenerateLibActivity extends ChainActivity {


                        static getClassAnnations():any  {
                            return {"name":"GenerateLibActivity","params":{}};
                        }
                   }

